import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  sentText: {
    color: "#C9BE3B",
    fontSize: "16px",
    fontWeight: 600,
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      textAlign: "left",
    },
  },
  acceptedText: {
    color: theme.palette.success.main,
    fontWeight: 600,
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      textAlign: "left",
    },
  },
  dateText: {
    marginLeft: theme.spacing(1),
    textAlign: "right",
    fontSize: "16px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "13px",
      textAlign: "left",
    },
  },
  rejectedText: {
    color: theme.palette.error.main,
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      marginLeft: "45px",
    },
  },
  approveButton: {
    minWidth: "84px",
    minHeight: "38px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "70px",
      minHeight: "27px",
    },
  },
  sendButton: {
    display: "flex",
    justifyContent: "center",
    marginRight: "10px",
    minWidth: "160px",
    minHeight: "38px",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
      marginRight: "initial",
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "134px",
      minHeight: "27px",
      marginBottom: 0,
    },
  },
  approvedButton: {
    color: theme.palette.success.main,
    backgroundColor: theme.palette.success.main,
  },
  approvedButtonBorder: {
    backgroundColor: "#41B25B33",
    "&:hover": {
      backgroundColor: "#41B25B33",
      cursorEvents: "none",
      cursor: "unset",
    },
    color: theme.palette.success.main,
    "&.MuiButton-outlined": {
      borderColor: theme.palette.success.main,
    },
  },
  actionButtonWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexGrow: 1,
    justifyContent: "flex-end",
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-end",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
  },
  buttonText: {
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      fontSize: "13px",
      lineHeight: 1.3,
    },
  },
}))

export default styles
